import { CargoTemperatureLogEntry } from '../../types/ViewModel/CargoTempLog/CargoTemperatureLog';
import { CargoTemperatureLogEntryBM } from '../../types/BusinessModel/CargoTempLog/CargoTemperatureLogBM';
import { getDateFromISO } from 'odfjell-date-time-utils/dateTimeUtils';
import { DateTimeFormat, formatDateTime } from 'odfjell-date-time-utils/dateTimeFormatter';

export const mapCargoTemperatureLog = (bm: CargoTemperatureLogEntryBM): CargoTemperatureLogEntry => {
    return {
        cargoTemperatureLogId: bm.cargoTemperatureLogId,
        logDateId: bm.logDateId,
        tankId: bm.tankId,
        cargoTemperatureFieldId: bm.cargoTemperatureFieldId,
        cargoNumber: bm.cargoNumber,
        loggedTimeLocalTime: getDateFromISO(bm.loggedTimeLocalTime),
        loggedTimeUTC: getDateFromISO(bm.loggedTimeUTC, 'utc'),
        value: bm.value,
        isOnBoard: bm.isOnBoard,
        comment: bm.comment,
    };
};

export const mapCargoTemperatureLogs = (bms: CargoTemperatureLogEntryBM[]): CargoTemperatureLogEntry[] =>
    bms ? bms.map((bm) => mapCargoTemperatureLog(bm)) : [];

export const mapCargoTemperatureLogBm = (vm: CargoTemperatureLogEntry): CargoTemperatureLogEntryBM => {
    return {
        cargoTemperatureLogId: vm.cargoTemperatureLogId,
        logDateId: vm?.logDateId ? vm.logDateId : undefined,
        tankId: vm.tankId,
        cargoTemperatureFieldId: vm.cargoTemperatureFieldId,
        cargoNumber: vm.cargoNumber,
        loggedTimeLocalTime: formatDateTime(vm.loggedTimeLocalTime, DateTimeFormat.queryFormats.dateTime),
        loggedTimeUTC: formatDateTime(vm.loggedTimeUTC, DateTimeFormat.queryFormats.dateTime, 'utc'),
        value: vm.value,
        isOnBoard: vm.isOnBoard,
        comment: vm.comment,
    };
};

export const mapCargoTemperatureLogBms = (vms: CargoTemperatureLogEntry[]): CargoTemperatureLogEntryBM[] =>
    vms ? vms.map((vm) => mapCargoTemperatureLogBm(vm)) : [];
